"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ColorPickerToolList_1 = __importDefault(require("./ColorPickerToolList"));
exports.getColorOfColorPickerTool = function (ref) { return (ref.current ? ref.current.getPickedColor() : ''); };
var ColorPickerToolListContainer = function (_a) {
    var setThemeColorsFn = _a.setThemeColorsFn;
    var PRIMARY_REF = react_1.useRef(null);
    var SECONDARY_REF = react_1.useRef(null);
    var labelsAndRefs = [
        { tabLabel: 'primary', ref: PRIMARY_REF, },
        { tabLabel: 'secondary', ref: SECONDARY_REF, },
    ];
    var handleSetThemeColor = function () {
        var themeColors = {
            primary: exports.getColorOfColorPickerTool(labelsAndRefs[0].ref),
            secondary: exports.getColorOfColorPickerTool(labelsAndRefs[1].ref),
        };
        if (setThemeColorsFn) {
            setThemeColorsFn(themeColors);
        }
    };
    return (react_1.default.createElement(ColorPickerToolList_1.default, { labelsAndRefs: labelsAndRefs, handleSetThemeColorFn: handleSetThemeColor }));
};
exports.default = ColorPickerToolListContainer;
